/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Directive, ElementRef, HostListener} from '@angular/core';
import {HotKeyService} from './hot-key.service';
import {LoggerService} from '../../../modules/shared/services/logger.service';

@Directive({
    selector: '[csHotKeys]',
})
export class HotKeysDirective {

    constructor(
        private logger: LoggerService,
        private hotKeyService: HotKeyService,
    ) {
    }

    @HostListener('window:keydown', ['$event'])
    private onKeyDown(evt: KeyboardEvent) {
        const tagName = (evt.target as HTMLElement).tagName;
        if ('input' !== tagName.toLowerCase() && 'textarea' !== tagName.toLowerCase()) {
            const code = evt.key;
            if (code && !(evt.ctrlKey || evt.altKey)) {
                const val = (evt.shiftKey) ? code : code.toLowerCase();
                if ('' !== val) {
                    this.hotKeyService.trigger(val);
                    evt.stopPropagation();
                }
            }
        }
    }
}
